import React from 'react';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { actionWidgetActivity as ActionWidgetActivityView } from 'ui/views/widgets/actionWidgetActivity';
import { ActionWidgetActivityService } from 'services/actionWidgetActivity';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { ActionWidgetActivity } from 'ui/containers/ActionWidgetActivity';
 *
 * // render
 * <ActionWidgetActivity propName='propValue'/>
 */
export class ActionWidgetActivity extends React.Component {
    
    /**
     * @param {object} props - props
     */
    constructor( props ) {
        super( props );
  
        // component state
        this.state = {
            isFetching: true,
            networkStatus: undefined,
            componentData: undefined,
        };

        // create service instance
        this.actionWidgetActivityService = new ActionWidgetActivityService();
        
        // start component data fetch
        this.fetchComponentData();
    }

    /*********************************************/

    /**
     * @desc Fetch component response.
     */
    async fetchComponentData() {
        log.debug( 'actionWidgetActivity.fetchComponentData()' );

        // cancel ongoing request
        this.actionWidgetActivityService.cancel();

        // get status and service data
        const { status, data } = await this.actionWidgetActivityService.fetchComponentData( {
            url: this.props.widget.url,
            data: this.props.requestPayload
        } );

        // check if response status was success
        if( SERVICE_RESPONSE_STATUS.SUCCESS !== status ) {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.FAILURE
            } );
        } else {
            this.setState( {
                isFetching: false,
                networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
                componentData: data,
            } );
        }
    }

    /*********************************************/

    /**
     * @desc When component unmounts, cleanup resouces.
     */
    componentWillUnmount() {
        this.actionWidgetActivityService.cancel(); // cancel ongoing requests
    }

    /**
     * @desc Render a React view component
     */
    render() {
        return (
            <ActionWidgetActivityView
                isFetching={ this.state.isFetching }
                networkStatus={ this.state.networkStatus }
                { ...this.state.componentData }
            />
        );
    }
}

// set display name
ActionWidgetActivity.displayName = 'ActionWidgetActivity';

// set default props
ActionWidgetActivity.defaultProps = {};

// prop types
ActionWidgetActivity.propTypes = {};
